module.exports = "<div class=\"alert alert-success fade show\" role=\"alert\">\n      <h4 class=\"alert-heading\">Well done!</h4>\n      <p>Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer\n            so that you can see how spacing within an alert works with this kind of content.</p>\n      <hr>\n      <p class=\"mb-0\">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Alerts/AlertContent.html
// module id = 422
// module chunks = 0